/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState,useRef } from 'react';
import Loading from 'wrappers/Loading';
import Page from 'components/Page';
import Breadcrumcomponent from 'components/BreadCrumbMex/BreadCrumb';
import useQueryParams from 'hooks/useQueryParams';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import { useNavbarContext } from 'contexts/NavbarContext';
import { urlEmisionPoliza, urlLinkEncuestas, registroEncuesta,rechazoEncuesta } from 'constants/urls';
import { consumirServicioEncirptacion } from 'api';
import { ApiKeyFetch } from "api/fetchers/apiKey";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

const ContainerFinalCompra = ({ history }) => {
  const { codProducto, idPoliza } = useQueryParams();
  const { setProductoActivo } = useNavbarContext();
  const [numPoliza, setNumPoliza] = useState('');
  const [loading, setLoading] = useState(false);
  const init = useCallback(async () => {
    const Data = {
      datosCotizador: {
        prodCodigo: codProducto,
        cotPasoCodigo: 'listarNroPoliza',
        polCodigo: idPoliza,
      },
    };
    setLoading(true);
    const res = await consumirServicioEncirptacion(urlEmisionPoliza, Data);

    if (res.transaccion && res?.catalogo?.numeroPolizaMostrar) {
      setNumPoliza(res?.catalogo?.numeroPolizaMostrar);
      loadEncuesta();
    }

    console.log('RES: ', res);
    setLoading(false);
  }, []);

  useEffect(() => {
    setProductoActivo(codProducto);
    init();
  }, []);

   //--------- Toast Encuesta-----------
   const myToastEncuestas = useRef(null);

   const closeToastEnceusta = () => {   
     myToastEncuestas.current.clear();
   }

   const rechazarEncuesta = async () => {     
    const res = await ApiKeyFetch.instance().post(rechazoEncuesta+idPoliza,{});    
    if (res.transaccion === true ) {           
      closeToastEnceusta();
    }      
  }
 
   const completeEncuesta = async () => {     
     setLoading(true);  
     const res = await ApiKeyFetch.instance().post(registroEncuesta+idPoliza+'&redirect=no',{});    
     if (res.transaccion === true && res?.urlRedirecionarEncuesta !== '') {           
       window.location.href=res?.urlRedirecionarEncuesta
     }        
   }
 
   const loadEncuesta = async () => {  
     const res = await ApiKeyFetch.instance().post(urlLinkEncuestas+idPoliza,{});
     if (res.transaccion === true) {        
       myToastEncuestas.current.show({ severity: 'info', sticky: true, content: (
         <div className="p-flex p-flex-column" style={{flex: '1'}}>
             <div className="p-text-center" style={{textAlign:'center'}}>
                 <i className="pi pi-question" style={{fontSize: '3rem'}}></i>
                 <h4>{res?.msgEncuesta}</h4>
                 <p>{res?.msgEncuestaSub}</p>
             </div>
             <div className="row">
                 <div className="col-6">
                     <Button onClick={() =>completeEncuesta()} type="button" label="Yes" className="p-button-success w-100" />
                 </div>
                 <div className="col-6">
                     <Button onClick={() =>rechazarEncuesta()} type="button" label="No" className="p-button-secondary w-100" />
                 </div>
             </div>
             <div className="row">
                  <div className="col-1"></div>
                  <div className="col-10 my-2">
                      <Button onClick={() =>closeToastEnceusta()} type="button" label="Responder más tarde" className="p-button-info w-100" />
                  </div>
                  <div className="col-1"></div>
              </div>
         </div>
     ) });    
     }
   };
 //--------- Fin Toast Encuesta-----------

  return (
    <Loading loading={loading}>
      <Toast ref={myToastEncuestas} position="bottom-center" /> 
      <div className="cr-content">
        <Page>
          <Breadcrumcomponent
            {...PASOS_BREADCRUMBS[codProducto].breadCrumb}
            subtitle="Cotización"
          />

          <div className="row justify-content-center">
            <div className="col-md-10 card-login-mex py-5 text-center">
              <h1 className="display-4 font-mex">¡Felicidades!</h1>
              <h5 className="font-mex  mb-5" style={{ fontSize: '20px' }}>
                El proceso de contratación de tu póliza ha finalizado
                <br />
                En breve recibirás en el mail que registraste tu póliza.
              </h5>

              {numPoliza && (
                <React.Fragment>
                  <h4 className="font-mex mt-5">Número de póliza</h4>
                  <h5 className="font-mex mb-3">{numPoliza}</h5>
                </React.Fragment>
              )}
            </div>
            <div className="col-md-10">
              <div className="row justify-content-end">
                <div className="col-lg-4">
                  <button
                    className="btn btn-block btn btn-siguiente-api"
                    onClick={() => history.push('/')}
                  >
                    Volver a pagina principal
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default ContainerFinalCompra;
